import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CircularProgress,
} from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import WorkIcon from "@mui/icons-material/Work";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const TeamStatus = ({ teamData }) => {
  const { teamMembers, projectsCompleted, teamStatus } = teamData;

  return (
    <Box sx={{}}>
      <Grid
        sx={{
          alignItems: "center",
          flexDirection: "row",
          padding: "25px",
          justifyContent: "center",
        }}
        container
        spacing={3}
      >
        <Grid item xs={3} md={4}>
          <Card>
            <CardContent>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <GroupIcon color="primary" fontSize="large" />
                </Grid>
                <Grid item>
                  <Typography variant="h5">{teamMembers}</Typography>
                  <Typography color="textSecondary">Team Members</Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={3} md={4}>
          <Card>
            <CardContent>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <WorkIcon color="primary" fontSize="large" />
                </Grid>
                <Grid item>
                  <Typography variant="h5">{projectsCompleted}</Typography>
                  <Typography color="textSecondary">
                    Projects Completed
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={3} md={4}>
          <Card>
            <CardContent>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  {teamStatus === "active" ? (
                    <CheckCircleIcon color="success" fontSize="large" />
                  ) : (
                    <CircularProgress color="warning" />
                  )}
                </Grid>
                <Grid item>
                  <Typography variant="h5">
                    {teamStatus === "active" ? "Active" : "Inactive"}
                  </Typography>
                  <Typography color="textSecondary">Team Status</Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TeamStatus;
